export default __webpack_public_path__ + "static/media/stars.7759f7a2.jpg";